import { useAssistantClientActions } from '@/lib/realtime/features/useAssistantClientActions'

/**
 * Headless controller (desktop main window): executes device-local actions
 * dispatched by Benny's server-side tools, e.g. meeting recording start/stop.
 */
export function AssistantClientActionsController() {
  useAssistantClientActions()
  return null
}
